import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type PageTitleProps = ComponentProps<"h1">

function PageTitle(props: PageTitleProps) {
  const { className, ...h1Props } = props
  return <h1 className={cn("page-title", className)} {...h1Props} />
}

export default PageTitle
